module.exports = __webpack_public_path__ + "static/media/icon_keep.47de19b9.svg";